'use client';

/**
 * RoiTalkToBriCta — the ROI calculator's "Stop the bleeding — try Bri" CTA,
 * shared between RoiCalculatorStaticGrid (SSR fallback) and the live grid in
 * RoiCalculatorIsland (the IO-gated interactive island). Split out to its
 * own Client Component because TalkToBriModalTrigger's `children` is a
 * render prop (a function) — passing a function from a Server Component
 * into a Client Component isn't serializable across the RSC boundary
 * ("Functions cannot be passed directly to Client Components"), which broke
 * the build when RoiCalculatorStaticGrid (a Server Component, PR-D Task D3
 * fix) tried to render TalkToBriModalTrigger directly. Composing it here,
 * inside a single client module, keeps the function entirely on the client
 * side.
 */

import { Microphone } from '@phosphor-icons/react';
import TalkToBriModalTrigger from '@/components/voice/TalkToBriModalTrigger';

export function RoiTalkToBriCta() {
  return (
    <TalkToBriModalTrigger source="roi">
      {(open) => (
        <button
          type="button"
          onClick={open}
          aria-haspopup="dialog"
          data-testid="roi-talk-to-bri-cta"
          className="relative inline-flex w-full items-center justify-center gap-3 rounded-xl border-0 px-6 py-4 text-[15px] font-bold text-[var(--color-dark-bg)] shadow-[0_10px_40px_rgba(14,165,233,0.3)] transition-transform hover:-translate-y-0.5 hover:shadow-[0_14px_54px_rgba(14,165,233,0.5)]"
          style={{
            background:
              'linear-gradient(135deg, var(--color-blue) 0%, var(--color-blue-bright) 100%)',
            cursor: 'pointer',
          }}
        >
          <span
            className="inline-block h-2.5 w-2.5 rounded-full"
            style={{
              background: 'var(--color-error)',
              boxShadow: '0 0 14px var(--color-error)',
              animation: 'sigpulse 1.6s ease-in-out infinite',
            }}
          />
          Stop the bleeding — try Bri
          <Microphone weight="fill" className="h-4 w-4" />
        </button>
      )}
    </TalkToBriModalTrigger>
  );
}

export default RoiTalkToBriCta;
